<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate('comments.new_comment') }}
      </h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label> {{ translate('comments.visible') }} </label>
              <tree-select
                v-model="visible"
                :options="visible_list"
                :placeholder="translate('comments.visible')"
                :clearable="false"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label> {{ translate('comments.priority') }} </label>
              <tree-select
                  v-model="priority"
                  :options="priority_list"
                  :placeholder="translate('comments.priority')"
                  :clearable="false"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <TextAreaImage
                :value="text_comment"
                @input="input"
                ref="textComment"
            >

            </TextAreaImage>
          </div>
        </div>
        <div class="buttons">
          <button
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="add_comment"
            :disabled='disabled_btn'
          >
            {{ translate("comments.to_add") }}
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
          >
            {{ translate("btn.close") }}
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>
import TextAreaImage from "components/UIComponents/Plugins/TextAreaImage/Index"

export default {
  name: "NewComment",
  props: ['params'],
  components:{
    TextAreaImage
  },
  data () {
    return {
      disabled_btn: false,
      visible: 0,
      priority: 0,
      text_comment: ''
    }
  },

  computed:{
    priority_list(){
      return [
        { id: 0, label: "NORMAL" },
        { id: 1, label: "MEDIUM" },
        { id: 2, label: "HIGH" },
      ]
    },
    visible_list(){
      let list = this.$store.getters.getCommentsFilter.map((filter) => {
        return {label: this.translate(filter.name), id: filter.value}
      })
      this.visible = list[0].id
      return list
    }
  },

  watch:{
    text_comment(){
      this.$store.dispatch('updateNewCommentText', this.text_comment)
    }
  },

  created() {
    this.text_comment = this.$store.getters.getNewCommentText
  },
  mounted() {
    this.$refs.textComment.$el.querySelector('textarea').focus();
  },

  methods: {
    input(new_text){
      this.text_comment = new_text
    },
    cancel () {
      this.$emit('close')
    },
    add_comment(){
      this.disabled_btn = true

      let params = {
        ...this.params,
        filter: this.visible,
        priority: this.priority,
        text: this.text_comment
      }

      this.$http.v1.addComment(params, () => {
        this.global_notify('info', this.translate('comments.new_comment_success'))
        this.$store.dispatch('clearNewCommentText')
        this.$emit('update')
        this.$emit('close')
      },(bad_answer) => {
        this.bad_answer_handler(bad_answer)
        this.disabled_btn = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .modal_card{
    width: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    padding: 10px;

    .header{
      .title{
        margin-top: 15px;
        text-align: center;
      }
    }
    .content{
      textarea{
        background-color: #fffcf5;
        border-radius: 4px;
        color: #66615b;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        box-shadow: none;
        border: 1px solid #e8e8e8;
        height: 200px;
      }
    }
    .buttons{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
  }

</style>
